import * as React from "react"

interface ErrorBoundaryProps {
  children: React.ReactNode
  fallback: React.ReactNode
  onError?: (error: Error) => void
}

interface ErrorBoundaryState {
  hasError: boolean
}

/*
 * Simple error boundary to handle errors without unmounting the entire component tree.
 * Provide a `fallback` ui and optional `onError` handler.
 * Errors tracked automatically via TrackJS.
 * */
export class LocalErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = { hasError: false }
  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  constructor(props: ErrorBoundaryProps) {
    super(props)
  }

  componentDidCatch(error: Error): void {
    TrackJS?.track(error)
    this.props.onError?.(error)
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return this.props.fallback
    }

    return this.props.children
  }
}
